import { DesktopAndTablet, Mobile } from 'utils/responsiveQueries';
import { NavigationMenu, Switcher, PostmanCollection } from 'components'

import MobileDocsNavigation from './MobileDocsNavigation';
import styles from './CombinedDocsNavigation.module.scss';

const CombinedDocsNavigation = ({ location = {}, isSwitcherOpen, apiVersions, selectedVersion = 0 }) => {
  let api = null;
  if (!!apiVersions.length) {
    api = apiVersions.find(c => c.version === selectedVersion) || {};
  }
  const isApisPage = location.pathname.indexOf('/apis') !== -1;

  return (
    <div className={styles['combined-docs-navigation']}>
      <DesktopAndTablet>
        <div className={styles['combined-docs-navigation__wrapper']}>
          <NavigationMenu
            className="sidebar"
          />
        </div>
        <div className={styles['combined-docs-navigation__switcher']}>
          {isApisPage && api && <PostmanCollection api={api} />}
          <span>{isSwitcherOpen ? 'Dark Theme' : 'Light Theme'}</span>
          <Switcher handleDiameter={16} height={11} width={27} />
        </div>
      </DesktopAndTablet>
      <Mobile>
        <MobileDocsNavigation
          location={location}
        />
      </Mobile>
    </div>
  );
};

export default CombinedDocsNavigation;
